/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginInputModel
 */
export interface LoginInputModel {
    /**
     * 
     * @type {string}
     * @memberof LoginInputModel
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginInputModel
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginInputModel
     */
    password: string;
    /**
     * 
     * @type {boolean}
     * @memberof LoginInputModel
     */
    rememberLogin?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LoginInputModel
     */
    returnUrl?: string | null;
}

/**
 * Check if a given object implements the LoginInputModel interface.
 */
export function instanceOfLoginInputModel(value: object): value is LoginInputModel {
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function LoginInputModelFromJSON(json: any): LoginInputModel {
    return LoginInputModelFromJSONTyped(json, false);
}

export function LoginInputModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginInputModel {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'] == null ? undefined : json['username'],
        'email': json['email'] == null ? undefined : json['email'],
        'password': json['password'],
        'rememberLogin': json['rememberLogin'] == null ? undefined : json['rememberLogin'],
        'returnUrl': json['returnUrl'] == null ? undefined : json['returnUrl'],
    };
}

export function LoginInputModelToJSON(json: any): LoginInputModel {
    return LoginInputModelToJSONTyped(json, false);
}

export function LoginInputModelToJSONTyped(value?: LoginInputModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'email': value['email'],
        'password': value['password'],
        'rememberLogin': value['rememberLogin'],
        'returnUrl': value['returnUrl'],
    };
}

